var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewmessagePagePhotos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1249 6.49581L15.0789 0.564708C14.9279 0.126848 14.4839 -0.105765 14.0899 0.0468541L0.492072 5.27065C0.0980767 5.42221 -0.100921 5.89902 0.0510772 6.33688L2.20705 12.5901V9.23981C2.20705 7.72624 3.35504 6.49581 4.76702 6.49581H8.35998L12.6449 3.32975L15.1239 6.49581H17.1249ZM19.2378 8.42198H4.76702C4.66564 8.42181 4.56525 8.44297 4.47175 8.48421C4.37825 8.52545 4.29351 8.58594 4.22253 8.66213C4.15155 8.73831 4.09574 8.82866 4.05839 8.92786C4.02104 9.02706 4.0029 9.13312 4.00503 9.23981V19.1548C4.00603 19.6221 4.34802 20 4.76702 20H19.2378C19.6578 20 19.9998 19.6221 19.9998 19.1548V9.23981C20.002 9.13312 19.9838 9.02706 19.9465 8.92786C19.9091 8.82866 19.8533 8.73831 19.7823 8.66213C19.7113 8.58594 19.6266 8.52545 19.5331 8.48421C19.4396 8.44297 19.3392 8.42181 19.2378 8.42198ZM17.9999 17.8949H6V15.7898L7.98398 11.5607L10.7519 15.1772L13.3499 12.3753L16.6879 11.107L17.9999 14.7373V17.8949Z",
    fill: "#2D5063"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewmessagePagePhotos);
export default __webpack_public_path__ + "static/media/newmessage_page_photos.da0c8764ecd7f6cd9ca5579c8ab3c9c8.svg";
export { ForwardRef as ReactComponent };